export type FollowUpQuestion = {
  question: string;
};

export type FollowUpQuestionCategory = {
  category: string;
  questions: string[];
};

export type FollowUpQuestionContent = {
  followUpQuestions: FollowUpQuestionCategory[];
  hasError?: boolean;
  errorMessage?: string;
};

export const isCategorizedFollowUpQuestions = (data: unknown): data is FollowUpQuestionContent => {
  if (!data || typeof data !== 'object' || !('followUpQuestions' in data)) {
    return false;
  }

  const candidateData = data as { followUpQuestions: unknown };

  return Array.isArray(candidateData.followUpQuestions)
    && candidateData.followUpQuestions.every((item: unknown) => {
      if (!item || typeof item !== 'object') return false;
      const candidateItem = item as { category?: unknown; questions?: unknown };
      return typeof candidateItem.category === 'string'
        && Array.isArray(candidateItem.questions);
    });
};

/**
 * Converts a flat array with <b> category markers to categorized structure
 * Format: ["<b>Category Name</b>", "question1", "question2", "<b>Next Category</b>", "question3"]
 */
export const convertFlatArrayToCategorizedQuestions = (
  flatArray: string[],
): FollowUpQuestionCategory[] => {
  const categories: FollowUpQuestionCategory[] = [];
  let currentCategory: FollowUpQuestionCategory | null = null;

  const pushCurrentCategory = () => {
    if (currentCategory && currentCategory.questions.length > 0) {
      categories.push(currentCategory);
    }
  };

  flatArray.forEach((item) => {
    if (item.includes('<b>') && item.includes('</b>')) {
      const categoryName = item.replace(/<\/?b>/g, '').trim();
      pushCurrentCategory();
      currentCategory = {
        category: categoryName,
        questions: [],
      };
    } else {
      if (!currentCategory) {
        currentCategory = {
          category: 'General',
          questions: [],
        };
      }

      currentCategory.questions.push(item.trim());
    }
  });

  pushCurrentCategory();

  return categories;
};

/**
 * Wrapper function that returns the full FollowUpQuestions structure
 */
export const convertFlatArrayToFollowUpQuestions = (
  flatArray: string[],
): FollowUpQuestionContent => ({
  followUpQuestions: convertFlatArrayToCategorizedQuestions(flatArray),
});
